import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function WhyBookUs() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-sand-light" data-id="element-243">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-244">
        <div className="text-center mb-16" data-id="element-245">
          <h2 className="text-4xl font-heading font-bold text-ocean-dark mb-4" data-id="element-246">
            {t.whyBookUs.title}
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto rounded-full" data-id="element-247" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-248">
          {t.whyBookUs.cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-249">
              <div className="bg-turquoise/10 p-3 rounded-full text-turquoise flex-shrink-0" data-id="element-250">
                <ShieldCheck size={24} data-id="element-251" />
              </div>
              <p className="font-medium text-gray-800 pt-1" data-id="element-252">{card}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}